module.exports =
  '_FRIEND':
    "TITLE": "友達設定"
    "NAME": "名前"
    "EMAIL": "メールアドレス"
    "ENTER_NEW_FRIEND": "新しい友達を入力"
    "ENTER_EMAIL": "メールアドレスを入力"
    "HDCP_INVALID": "HDCPの値が不正です"



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/friend/i18n/ja.coffee